// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__kD_iX","container":"styles_container__mLPd5","light":"styles_light__adCJl"};